import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main__footer--container col row" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "s-mt-md"
}
const _hoisted_4 = { class: "col-grow s-pt-lg" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "col-xs-12 col-sm-5 col-md-4 s-pl-xs s-pr-xs s-mb-sm" }
const _hoisted_7 = { class: "row footer_info" }
const _hoisted_8 = { class: "col-grow footer_info--text s-pr-xl s-mb-sm" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "col-grow footer_info--text s-pr-xl"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "col-xs-12 col-sm-4 col-md-4 s-pl-md s-pr-xs s-mb-sm" }
const _hoisted_13 = { class: "row footer_text_header" }
const _hoisted_14 = { class: "col-grow s-pr-xl s-mb-sm" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "col-xs-12 column justify-end items-end q-mt-xs" }
const _hoisted_17 = { class: "col-grow" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "col-grow" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "col-grow" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "col-grow" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "col-xs-12 row" }
const _hoisted_26 = { class: "col-xs-12 col-md-7 col-lg-6" }
const _hoisted_27 = { class: "footer__text--copyright" }
const _hoisted_28 = { class: "col-xs-12 col-md-5 col-lg-6 text-right" }
const _hoisted_29 = {
  key: 0,
  class: "col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_russian_software_registry = _resolveComponent("russian-software-registry")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_feedback_modal = _resolveComponent("feedback-modal")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, { class: "main__footer column justify-end items-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-xs-12 col-sm-3 col-md-4 column justify-between s-pl-xs s-pr-xs s-mb-sm", { 'items-center': _ctx.isMobile }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`${_ctx.isMobile ? 'column justify-start items-start' : 'row justify-between items-center'}`)
          }, [
            _createVNode(_component_router_link, {
              to: { name: _ctx.routerMainPageName }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "header_logo",
                  src: `${_ctx.routerInitialPath}${_ctx.REGION_ENVIRONMENT}/images/logo.svg`,
                  alt: ""
                }, null, 8, _hoisted_2)
              ]),
              _: 1
            }, 8, ["to"]),
            (_ctx.isVisibleLabelWithRussianRegistry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_russian_software_registry)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: _ctx.ADMIN_URL,
              class: "s-link",
              target: "_blank",
              rel: "nofollow noopener"
            }, [
              _cache[2] || (_cache[2] = _createTextVNode(" Перейти в ЛК администратора")),
              _createVNode(_component_s_icon, {
                name: "app:arrow-normal-right",
                size: "small",
                color: "brand"
              })
            ], 8, _hoisted_5)
          ]),
          (_ctx.isVisibleFeedbackBtn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["s-mb-md", { 'col-xs-12': _ctx.isMobile }])
              }, [
                _createVNode(_component_s_btn, {
                  label: "Обратная связь",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = true))
                })
              ], 2))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                innerHTML: _ctx.t('support.address')
              }, null, 8, _hoisted_9)
            ]),
            (_ctx.t('support.phone'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_s_icon, {
                      name: "app:telephone",
                      class: "s-mr-sm not-hovered"
                    }),
                    _createElementVNode("a", {
                      class: "s-link",
                      href: `tel:${_ctx.t('support.phone')}`,
                      target: "_blank",
                      rel: "nofollow noopener"
                    }, _toDisplayString(_ctx.t('support.phone')), 9, _hoisted_11)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, _toDisplayString(_ctx.t('support.description')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_s_icon, {
                  name: "app:mail",
                  class: "s-mr-sm not-hovered"
                }),
                _createElementVNode("a", {
                  class: "s-link",
                  href: `mailto:${_ctx.t('support.email')}`,
                  target: "_blank",
                  rel: "nofollow noopener"
                }, _toDisplayString(_ctx.t('support.email')), 9, _hoisted_15)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("a", {
                  class: "s-link",
                  target: "_blank",
                  rel: "nofollow noopener",
                  href: _ctx.REGULATIONS_ON_PERSONAL_DATA_PROCESSING
                }, " Положение об обработке ПДн ", 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", {
                  class: "s-link",
                  target: "_blank",
                  rel: "nofollow noopener",
                  href: _ctx.PRIVACY_POLICY
                }, " Политика защиты и обработки ПДн ", 8, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("a", {
                  class: "s-link",
                  target: "_blank",
                  rel: "nofollow noopener",
                  href: _ctx.AGREEMENT_PERSONAL_DATA
                }, " Согласие пользователя на обработку ПДн ", 8, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("a", {
                  class: "s-link",
                  target: "_blank",
                  rel: "nofollow noopener",
                  href: _ctx.MANUAL_USER
                }, " Руководство пользователя ", 8, _hoisted_24)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, " © 2022 — " + _toDisplayString(_ctx.currentYear) + " " + _toDisplayString(_ctx.t('systemFullName')), 1),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "footer__text--company q-mt-xs" }, [
              _createTextVNode(" Разработка и поддержка "),
              _createElementVNode("a", {
                class: "s-link",
                href: "https://uriit.ru",
                target: "_blank",
                rel: "noopener noreferrer"
              }, " «Югорский НИИ информационных технологий» ")
            ], -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "s-link",
                to: { name: 'information' }
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Документация на систему ")
                ])),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (_ctx.isVisibleLinksToEthnoportalInPortal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "text-semibold" }, "Полезные источники:", -1),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      class: "s-link",
                      target: "_blank",
                      rel: "nofollow noopener",
                      href: "https://ethnoportal.admhmao.ru"
                    }, " Портал \"Наш дом\" ")
                  ], -1),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      class: "s-link",
                      target: "_blank",
                      rel: "nofollow noopener",
                      href: "https://etno.uriit.ru"
                    }, " Этнокультурный банк финно-угорских народов ")
                  ], -1),
                  _createElementVNode("div", null, null, -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_feedback_modal, {
          show: _ctx.showDialog,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDialog) = $event))
        }, null, 8, ["show"])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "main__footer--pattern q-mt-md" }, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "main__footer--green" }, null, -1))
    ]),
    _: 1
  }))
}